import React from "react";
import SmartOnlineLink from "./SmartOnlineLink";
import Store from "./../../../content/Store";
import Contentify from "../../../content/Contentify";

export const MakeAClaimLink = ( {content }) =>{
  let { linkText, pathTo, iconName, id } = content;

  return (
        <SmartOnlineLink linkText={linkText} pathTo={pathTo} iconName={iconName} isExternalLink={false} id={id}/> 
  );
};

MakeAClaimLink.content = Store.MakeAClaimSmartLink;

export default Contentify(MakeAClaimLink);
